export default __webpack_public_path__ + "static/media/profile-bg-img.0ee647cd.jpg";